import Typography from "@material-ui/core/Typography";
import React, { FC, ReactNode } from "react";

import brandGenLogo from "../../assets/images/logo_blue_black.svg";
import classes from "./AuthFlowLayout.module.scss";

type AuthFlowLayoutProps = {
  children: ReactNode;
  heading: string;
  description: string;
};

const AuthFlowLayout: FC<AuthFlowLayoutProps> = ({ children, heading, description }) => {
  return (
    <div className={classes.container}>
      <div className={classes.authPageTextInfo}>
        <img src={brandGenLogo} alt="BrandGen Logo" />
        <Typography className={classes.heading} variant="h1">
          {heading}
        </Typography>

        <Typography className={classes.description}>{description}</Typography>
      </div>

      <div className={classes.authPageForm}>{children}</div>
    </div>
  );
};

export default AuthFlowLayout;
